import { createSlice } from '@reduxjs/toolkit'

const depositSlice = createSlice({
  name: 'depositData',
  initialState: {
    data: {
      selectedCoinId: '',
      selectedNetwork: '',
      depositAddress: '',
      // Bank details structure for fiat currencies
      bankDetails: {
        account_holder_full_name: '',
        iban: '',
        bank_name: '',
        swift_bic: '',
        bank_address: '',
        bank_country: '',
        bank_code: '',
        currency_id: '',
        reference_id: ''
      },
      // Crypto address structure for crypto currencies
      cryptoDetails: {
        currency: '',
        address: '',
        network: '',
        details: {},
        reference_id: '',
        state: ''
      }
    },
    coin: {}
  },
  reducers: {
    setSelectedCoinId: (state, action) => {
      state.data.selectedCoinId = action.payload
    },
    setSelectedNetwork: (state, action) => {
      state.data.selectedNetwork = action.payload
    },
    setDepositAddress: (state, action) => {
      state.data.depositAddress = action.payload
    },
    setDepositData: (state, action) => {
      state.coin = action.payload
    },
    setBankDetails: (state, action) => {
      state.data.bankDetails = action.payload
    },
    setCryptoDetails: (state, action) => {
      state.data.cryptoDetails = action.payload
    }
  }
})

export const { setSelectedCoinId, setSelectedNetwork, setDepositAddress, setDepositData, setBankDetails, setCryptoDetails } = depositSlice.actions

export default depositSlice.reducer